/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { RestlessTable } from "../../../_metronic/layout/components/Table";
import { useSubheader } from "../../../_metronic/layout";
import * as actions from "../../../redux/actions/notifications";
import { useDispatch, useSelector } from "react-redux";
import RestlessDateFormatter from "../../../_metronic/layout/components/Table/RestlessDateFormatter";
import { Alert } from "react-bootstrap";

export default function RestlessNotificationsPage({ history }) {
  const suhbeader = useSubheader();
  suhbeader.setTitle("Notifications");

  const { notificationsList, listLoading, notificationsCreated } = useSelector(
    (state) => ({
      notificationsList: state.notifications.notificationsList,
      listLoading: state.notifications.listLoading,
      notificationsCreated: state.notifications.notificationsCreated,
    })
  );

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.fetchNotifications());
  }, [dispatch]);

  const columns = [
    {
      dataField: "created_at",
      text: "Created",
      sort: true,
      formatter: RestlessDateFormatter,
    },
    {
      dataField: "type",
      text: "Attached to",
      sort: true,
    },
    {
      dataField: "id",
      text: "Attachment ID",
      sort: true,
    },
    {
      dataField: "categoryName",
      text: "Category",
      sort: true,
    },
    {
      dataField: "body",
      text: "Content",
      sort: true,
    },
  ];

  useEffect(() => {
    if (notificationsCreated) {
      setTimeout(() => actions.cleanVariables(dispatch), 3500);
    }
  }, [notificationsCreated]);

  //Functions to open the dialog
  const notificationsUIEvents = {
    openNotificationCreatePage: () => {
      actions.cleanVariables(dispatch)
      history.push(`/notifications/new`);
    },
  };

  const renderNotificationCreated = () => {
    return (
      <Alert
        variant="success"
        className="text-center"
        dismissible
        onClose={() => actions.cleanVariables(dispatch)}
      >
        Notification created successfully
      </Alert>
    );
  };

  return (
    <div>
      {listLoading ? (
        <div className="d-flex justify-content-center align-content-center">
          <span className="mx-3 spinner spinner-primary"></span>
        </div>
      ) : (
        <>
          {notificationsCreated && renderNotificationCreated()}
          <RestlessTable
            data={notificationsList}
            columns={columns}
            withPagination
            withNewButton
            newButton={{
              onClick: notificationsUIEvents.openNotificationCreatePage,
              text: "New Notification",
            }}
          />
        </>
      )}
    </div>
  );
}
